/** @jsx jsx */
import { Box, Button, Flex, Heading, LaunchIcon, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import payExpressLogo from "@/assets/logo-payexpress.svg";
import { JobRequest } from "@/data/job-requests/types/JobRequest";
import { useOnLanguageChange } from "@/hooks/Translations";

interface PayExpressBannerProps {
  jobRequest: JobRequest;
}

export const PayexpressBanner: FC<PayExpressBannerProps> = ({ jobRequest }) => {
  const { t } = useTranslation("session");

  const currentLang = useOnLanguageChange();

  if (!jobRequest?.payExpressConfig?.payExpressEnabled) {
    return null;
  }
  const payExpressLink =
    currentLang === "sv"
      ? "https://www.eworkgroup.com/sv/tjanster/konsulter-partners/hur-det-fungerar/payexpress"
      : "https://www.eworkgroup.com/services/professionals/how-it-works/payexpress";

  const handlePayExpressButtonClick = () => {
    window.open(payExpressLink, "_blank");
  };

  return (
    <Box backgroundColor="vg900" borderRadius="lg" p="sm">
      <Flex
        gap="sm"
        alignItems={["flex-start", null, "center"]}
        justifyContent={["flex-start", null, "space-between"]}
        flexDirection={["column", null, "row"]}>
        <img height="20" src={payExpressLogo} />
        <Flex flexDirection="column" gap="xxs">
          <Heading size="h-sm" color="n0">
            {t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.PAYEXPRESS.BANNER_TITLE")}
          </Heading>
          <Paragraph color="n0" size="p-sm">
            {t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.PAYEXPRESS.BANNER_INFO")}
          </Paragraph>
        </Flex>
        <Button
          variant="ghost"
          sx={{
            backgroundColor: "n0",
          }}
          iconRight={<LaunchIcon color="n1000" size="xs" />}
          size="sm"
          onClick={handlePayExpressButtonClick}>
          <Paragraph color="n1000">{t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.PAYEXPRESS.READ_MORE")}</Paragraph>
        </Button>
      </Flex>
    </Box>
  );
};
